import { Account, Location, Carrier, Importer } from '../entities/types';
import { User } from '../auth/types';
import { Destination } from '../entities/destination_type';
import { Notify } from 'types/entities/notify_type';

export interface Choice {
  value: string | number;
  display_name: string;
}

// Vehicle field names for permission checking
export const VEHICLE_FIELDS = {
  PICTURES: 'pictures',
  VIN: 'vin',
  NAME: 'name',
  FUEL_TYPE: 'fuel_type',
  MECHANICAL_STATUS: 'mechanical_status',
  KEYS: 'keys',
  STATUS: 'status',
  LOCATION: 'location',
  STOCK: 'stock',
  CARRIER: 'carrier',
  LOADER: 'loader',
  DESTINATION: 'destination',
  PRIVATE_NOTES: 'private_notes',
  CLIENT: 'client',
  IMPORTER: 'importer',
  NOTIFY: 'notify',
  // Admin-only or restricted fields
  ACCOUNT: 'account',
  WEIGHT: 'weight',
  VENDOR: 'vendor',
  WAREHOUSE_DELIVERY: 'warehouse_delivery',
  SHIPPING_LINE: 'shipping_line',
  INVOICE_DATE: 'invoice_date',
  SALE_AMOUNT: 'sale_amount',
  FEES_AMOUNT: 'fees_amount',
  GST_AMOUNT: 'gst_amount',
  PST_AMOUNT: 'pst_amount',
  TOTAL_AMOUNT: 'total_amount',
  CONTAINER: 'container',
  CONTAINER_NUMBER: 'container_number',
  TITLE_STATUS: 'title_status',
  COMMENT: 'comment',
  COMMENT_RESTRICTED: 'comment_restricted',
} as const;

// Tab visibility types
export const TAB_VISIBILITY_ADMIN = 'admin';
export const TAB_VISIBILITY_CLIENT = 'client';
export const TAB_VISIBILITY_WAREHOUSE = 'warehouse';
export const TAB_VISIBILITY_PUBLIC = 'public';

export const TAB_VISIBILITY_OPTIONS = [
  { value: TAB_VISIBILITY_CLIENT, label: 'Client' },
  { value: TAB_VISIBILITY_WAREHOUSE, label: 'Warehouse' },
  { value: TAB_VISIBILITY_PUBLIC, label: 'Public' },
];

export interface VehiclePictureTab {
  id: string;
  name: string;
  visibility: string[];
  is_default: boolean;
}

export interface VehiclePicture {
  id: string;
  user: string;
  vehicle: string;
  picture: string;
  is_cover: boolean;
  created: string;
  modified: string;
  tab?: string;
}

export interface VehicleFile {
  id: string;
  user?: string;
  vehicle?: string;
  type: string;
  file: string;
  name?: string;
  created?: string;
  modified?: string;
}

export interface Vehicle {
  id: string;
  account: Account;
  location: Location;
  stock: string;
  name: string;
  description: string;
  fuel_type: string;
  keys: number;
  vendor: string;
  warehouse_delivery: Choice;
  weight: string;
  invoice_date: string;
  sale_amount: number;
  fees_amount: number;
  gst_amount: number;
  pst_amount: number;
  total_amount: number;
  vin: string;
  technical_status: Choice;
  status: Choice;
  carrier: Carrier;
  client: User;
  destination: Destination;
  importer: Importer;
  notify: Notify;
  comment: string;
  comment_restricted: string;
  loader: string;
  shipping_line: Choice;
  container: string;
  container_number: string;
  title_status: string;
  cover_picture: VehiclePicture;
  pictures: VehiclePicture[];
  files: VehicleFile[];
  tabs?: VehiclePictureTab[];
}
